import { ICacheOptions } from '../models/core/cache-options';
import { CacheType } from '../models/enums/cacheTypeEnum';
import { IActionRequestDate } from '../models/core/action-request';
import { relativeTimeThreshold } from 'moment';
import { Log } from 'ng2-logger';

const _logger = Log.create('cacheService.ts');

export class CacheService {
    private readonly CacheMapList: ICacheOptions[] = [
        { actionName: 'GET_USER_HOME_MY_COURSES', cacheDurationInMinutes: 5, cacheType: CacheType.StandartTime },
        { actionName: 'GET_ANNOUNCEMENT_LIST', cacheDurationInMinutes: 5, cacheType: CacheType.StandartTime },
        { actionName: 'GET_MY_ACTIVITY_STATS', cacheDurationInMinutes: 5, cacheType: CacheType.StandartTime },
        { actionName: 'GET_MY_GRADES', cacheDurationInMinutes: 5, cacheType: CacheType.StandartTime },
        { actionName: 'GET_MY', cacheDurationInMinutes: 5, cacheType: CacheType.StandartTime },
        { actionName: 'GET_HOME_BOX', cacheDurationInMinutes: 5, cacheType: CacheType.StandartTime },
        { actionName: 'GET_MY_GROUP', cacheDurationInMinutes: 5, cacheType: CacheType.StandartTime }
    ];

    public AddOrUpdateActionRequest(actionItems: IActionRequestDate) {
        if (localStorage.getItem('actions_request') === null) {
            const localStorageItem: IActionRequestDate[] = new Array();
            localStorageItem.push(actionItems);
            localStorage.setItem('actions_request', JSON.stringify(localStorageItem));
        } else {
            const localStorageItem: IActionRequestDate[] = JSON.parse(localStorage.getItem('actions_request')!);
            const updateItem = localStorageItem.find(item => item.actionName === actionItems.actionName);
            const updateIndex = localStorageItem.indexOf(updateItem!);
            if (updateIndex > -1) {
                localStorageItem[updateIndex] = actionItems;
            } else {
                localStorageItem.push(actionItems);
            }
            localStorage.setItem('actions_request', JSON.stringify(localStorageItem));
        }
    }

    public CheckCache(actionItems: IActionRequestDate) {
        const localStorageItem: IActionRequestDate[] = JSON.parse(localStorage.getItem('actions_request')!);
        if (localStorageItem) {
            const thisCacheOptions: ICacheOptions = this.CacheMapList.find(item => item.actionName === actionItems.actionName)!;
            if (thisCacheOptions) {
                if (thisCacheOptions.cacheType === CacheType.StandartTime) {

                    const thisCachedItem = localStorageItem!.findIndex(item => item.actionName === actionItems.actionName && new Date(new Date(item.firstRequestDate!).getTime() + thisCacheOptions.cacheDurationInMinutes * 60000) > new Date());

                    if (thisCachedItem >= 0) {
                        return true;
                    } else { return false; }
                } else if (thisCacheOptions.cacheType === CacheType.LoadBeforeDate) {
                    const thisCachedItem = localStorageItem!.findIndex(item => item.actionName === actionItems.actionName && new Date(new Date(item.firstRequestDate!).getTime() + thisCacheOptions.cacheDurationInMinutes * 60000) > new Date());
                    if (thisCachedItem >= 0) {
                        return true;
                    } else { return false; }
                } else if (thisCacheOptions.cacheType === CacheType.StandartTimeForContent) {
                    const thisCachedItem = localStorageItem!.findIndex(item => item.actionName === actionItems.actionName && item.contextId === actionItems.contextId && new Date(new Date(item.firstRequestDate!).getTime() + thisCacheOptions.cacheDurationInMinutes * 60000) > new Date());
                    if (thisCachedItem >= 0) {
                        return true;
                    } else { return false; }
                }
            } else {
                return false;
            }

        } else {
            return false;
        }
    }
    public GetCachedDate(actionName: string, contextId?: number): IActionRequestDate | undefined {
        const localStorageItem: IActionRequestDate[] = JSON.parse(localStorage.getItem('actions_request')!);
        if (localStorageItem) {
            if (actionName && !contextId) {
                return localStorageItem.find(item => item.actionName === actionName)!;
            } else if (actionName && contextId) {
                return localStorageItem.find(item => item.actionName === actionName && item.contextId === contextId)!;
            } else { return undefined; }
        } else { return undefined; }
    }
}